const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

const reasons = [
  {
    icon: 'ri-settings-3-line',
    title: '100% Mecánica — Sin Latonería',
    description: 'No hacemos de todo. Nos especializamos exclusivamente en repuestos mecánicos, lo que nos convierte en verdaderos expertos. Si es mecánica, lo tenemos.',
    number: '01',
    color: 'text-[#2563eb]',
    bg: 'bg-[#2563eb]/10',
    border: 'border-l-[#2563eb]',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'Respuesta en Minutos por WhatsApp',
    description: 'Escríbenos y te cotizamos en minutos. Sin formularios, sin esperas, sin intermediarios. Atención directa con quien sabe de repuestos.',
    number: '02',
    color: 'text-blue-400',
    bg: 'bg-blue-500/10',
    border: 'border-l-blue-500',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Más de 500 Referencias en Stock',
    description: 'Disponibilidad real para Chevrolet, Suzuki, Jeep y RAM. Repuestos originales y alternativos certificados — confirmamos existencia antes de que vengas.',
    number: '03',
    color: 'text-orange-400',
    bg: 'bg-orange-500/10',
    border: 'border-l-orange-500',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'En el Corazón Automotriz de Bogotá',
    description: 'Sector 7 de Agosto, Bogotá. La zona con mayor concentración de talleres y repuestos del país. Fácil acceso y entrega rápida en toda la ciudad.',
    number: '04',
    color: 'text-red-400',
    bg: 'bg-red-500/10',
    border: 'border-l-red-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantía Real en Cada Repuesto',
    description: 'Todos nuestros repuestos tienen garantía. Trabajamos con proveedores verificados. Si el repuesto falla, respondemos — así de simple.',
    number: '05',
    color: 'text-yellow-400',
    bg: 'bg-yellow-500/10',
    border: 'border-l-yellow-500',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Asesoría Técnica Sin Costo',
    description: 'No sabes el código exacto del repuesto? No importa. Nuestro equipo te ayuda a identificar la pieza correcta para tu vehículo antes de comprar.',
    number: '06',
    color: 'text-cyan-400',
    bg: 'bg-cyan-500/10',
    border: 'border-l-cyan-500',
  },
];

const stats = [
  { value: '500+', label: 'Referencias en stock' },
  { value: '4', label: 'Marcas especializadas' },
  { value: '5+', label: 'Años de experiencia' },
  { value: '100%', label: 'Enfoque mecánico' },
];

export default function WhyUs() {
  return (
    <section id="nosotros" className="bg-[#111111] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line"></i>
            Por Qué Elegirnos
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Atención Real,<br />
            <span className="text-[#2563eb]">Repuestos Disponibles</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            No somos una vitrina online. Somos un negocio real en Bogotá con stock físico, asesoría técnica y respuesta inmediata por WhatsApp.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-[#1a1a1a] rounded-xl p-6 text-center border border-gray-800">
              <div className="text-3xl md:text-4xl font-extrabold text-[#2563eb] mb-1">{stat.value}</div>
              <div className="text-gray-400 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className={`bg-[#1a1a1a] rounded-xl p-6 border-l-4 ${reason.border} border border-gray-800/60 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden`}
            >
              {/* Background number */}
              <span className="absolute top-3 right-4 text-6xl font-black text-white/[0.03] select-none">
                {reason.number}
              </span>

              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${reason.bg} mb-4`}>
                <i className={`${reason.icon} text-2xl ${reason.color}`}></i>
              </div>
              <h3 className="text-white font-bold text-base mb-2">{reason.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <p className="text-gray-400 text-base mb-5">¿Listo para cotizar? Escríbenos ahora y te atendemos de inmediato.</p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-3 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold px-10 py-4 rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-blue-900/30"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Cotizar por WhatsApp Ahora
          </a>
        </div>
      </div>
    </section>
  );
}
